// extracted by mini-css-extract-plugin
export var blogFaq = "blogFaq-module--blogFaq--e004e";
export var blogFaq__accordion = "blogFaq-module--blogFaq__accordion--a2f78";
export var blogFaq__accordionButton = "blogFaq-module--blogFaq__accordionButton--c9b4e";
export var blogFaq__accordionHeading = "blogFaq-module--blogFaq__accordionHeading--a5d21";
export var blogFaq__accordionItem = "blogFaq-module--blogFaq__accordionItem--2eadc";
export var blogFaq__accordionItemPanel = "blogFaq-module--blogFaq__accordionItemPanel--cc730";
export var blogFaq__accordionPanel = "blogFaq-module--blogFaq__accordionPanel--62a45";
export var blogFaq__accordionParagraph = "blogFaq-module--blogFaq__accordionParagraph--c0025";
export var blogFaq__arrowBox = "blogFaq-module--blogFaq__arrowBox--2d841";
export var blogFaq__contextArea = "blogFaq-module--blogFaq__contextArea--dcbae";
export var blogFaq__heading = "blogFaq-module--blogFaq__heading--2ce24";
export var blogFaq__headingArea = "blogFaq-module--blogFaq__headingArea--0c97f";